module.exports = __webpack_public_path__ + "static/terveystalo-99128ed2cfb85ab172f74f2151320820.svg";